import React from 'react';
import { Badge, Card, TitleText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './KnowBefore.module.less';
import RenderEcmRichText from '../../../components/Text/RenderEcmRichText';

function KnowBefore({ knowBeforeCards }) {
  return (
    <div>
      <TitleText type="medium" className={`${styles.card_section_title}`}>
        {knowBeforeCards.title}
      </TitleText>
      {knowBeforeCards.cards.map((card) => (
        <div className={styles.card} key={card.id}>
          <Card>
            <div>
              <div className={styles.title_wrapper}>
                <TitleText type="strong" className={styles.card_title}>
                  {card.key}
                </TitleText>
                {card.badge && (
                  <Badge
                    className={styles.badge}
                    type={card.badgeType}
                    contrast={card.badgeContrast}
                  >
                    {card.badge}
                  </Badge>
                )}
              </div>
              <div className={`${styles.card_description}`}>{card.description}</div>
              {card.text && (
                <RenderEcmRichText content={card.text} className={styles.text_content} />
              )}
            </div>
          </Card>
        </div>
      ))}
    </div>
  );
}

KnowBefore.propTypes = {
  knowBeforeCards: PropTypes.object.isRequired
};

export default KnowBefore;
